import { render, staticRenderFns } from "./ventures-whyVentureHer.vue?vue&type=template&id=6ddead84&scoped=true"
import script from "./ventures-whyVentureHer.vue?vue&type=script&lang=js"
export * from "./ventures-whyVentureHer.vue?vue&type=script&lang=js"
import style0 from "./ventures-whyVentureHer.vue?vue&type=style&index=0&id=6ddead84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddead84",
  null
  
)

export default component.exports